<template>
  <div class="m-card">
    <div class="header">Surface Temperature</div>
    <div class="content">
      <div class="item" v-for="(item, i) in dataTemp" :key="i">
        <div style="position: relative">
          <img src="@/assets/images/hino element/chart_mathlab.gif" alt="" />
          <h2
            style="font-weight: bold; z-index: 2; position: absolute; top: 0px"
          >
            0{{ i + 1 }}
          </h2>
        </div>
        <div>
          <h1 style="font-weight: bold">
            {{ item.surface_temperature.toFixed(2) }}
            <sup style="font-weight: 100">°C</sup>
          </h1>
        </div>
        <div class="box_3">
          <div class="max">max</div>
          <div class="temp">{{ max.toFixed(2) }}<sup>°C</sup></div>
          <div class="min">min</div>
          <div class="temp">{{ min.toFixed(2) }}<sup>°C</sup></div>
          <div
            style="
              grid-row: 3/4;
              grid-column: 1/3;
              display: flex;
              flex-direction: column;
              align-items: flex-end;
            "
          >
            <div class="date">Date : {{ time_stamp.split(" ")[0] }}</div>
            <div class="date">time : {{ time_stamp.split(" ")[1] }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dataTemp: Object,
    max: {
      type: Number,
      default: 0,
    },
    min: {
      type: Number,
      default: 0,
    },
    time_stamp: String,
  },
  data() {
    return {
      today: this.$moment().format("YYYY-MM-DD"),
      time: this.$moment().format("hh:mm:ss"),
    };
  },
  mounted() {
    this.selectData();
  },
  methods: {
    selectData() {},
  },
};
</script>

<style lang="scss" scoped>
.m-card {
  color: var(--text-color-2);
}
.content {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
img {
  width: 100%;
  z-index: 1;
  margin-top: 1rem;
}
.item {
  display: grid;
  grid: max-content/ 30% auto auto;
  align-items: center;
  justify-items: center;
  gap: 5px;
}
.box_3 {
  display: grid;
  grid: auto auto auto auto/min-content auto;
  gap: 5px;
}
.min {
  //   font-weight: 800;
  //   margin-bottom: 0.5rem;
  color: #f707ff;
}
.max {
  //   font-weight: 800;
  //   margin-bottom: 0.5rem;
  color: #8f07ff;
}
.temp {
  font-weight: 700;
  color: var(--text-color);
}
.date {
  font-size: 0.7rem;
}
.header {
  text-align: center;
  font-size: 2.25rem;
  font-weight: bold;
}
</style>